import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output
} from "@angular/core";
import { FormBuilder, FormControl, Validators } from "@angular/forms";
import { MatOptionSelectionChange } from "@angular/material/core";
import { Observable, of } from "rxjs";
import { debounceTime, map, switchMap, tap } from "rxjs/operators";

import {
  FranchiseResponseDTO,
  FranchiseNegotiationService
} from "@core/services/franchise-negotiation.service";

import {
  ClientFranchiseNegotiationFilterDTO,
  FranchiseNegotiationResponseDTO,
  Page
} from "@shared/models/franchise-auto-complete-dto";

@Component({
  selector: "app-smartfleet-franchise-auto-complete",
  templateUrl: "./franchise-auto-complete.component.html",
  styleUrls: ["./franchise-auto-complete.component.scss"],
  standalone: false
})
export class FranchiseAutoCompleteComponent implements OnInit, AfterViewInit {
  @Input() title = "";
  @Input() required = false;
  @Input() style: string;
  @Input() requiredText = "";
  @Input() negotiationId?: number;
  @Input() page = "";
  @Output() onChange = new EventEmitter<FranchiseResponseDTO>();

  loading = false;
  franchise = new FormControl();
  searchForm = this.fb.group({
    franchise: this.franchise
  });

  franchises$: Observable<FranchiseResponseDTO[]>;

  constructor(
    private fb: FormBuilder,
    private franchiseService: FranchiseNegotiationService
  ) {}

  ngOnInit() {
    if (this.required) {
      this.searchForm.controls.franchise.setValidators([Validators.required]);
    }

    if (this.page === "negotiation-form" && this.negotiationId) {
      this.setupNegotiationAutocomplete();
    } else {
      this.setupAutocomplete();
    }
  }

  private setupNegotiationAutocomplete() {
    this.franchises$ = this.franchise.valueChanges.pipe(
      debounceTime(200),
      tap(() => (this.loading = true)),
      switchMap((term: string) => {
        if (term && term.length > 0) {
          return this.franchiseService.getFranchisesAutocomplete(
            this.negotiationId!,
            term
          );
        } else {
          return of([]);
        }
      }),
      tap(() => (this.loading = false))
    );
  }

  private setupAutocomplete() {
    this.franchises$ = this.franchise.valueChanges.pipe(
      debounceTime(200),
      tap(() => (this.loading = true)),
      switchMap((term: string) => {
        if (term) {
          const filter: ClientFranchiseNegotiationFilterDTO = {
            page: 0,
            size: 10,
            sort: "name,asc",
            name: term
          };
          return this.franchiseService
            .listWithFilters(filter)
            .pipe(map((page) => page.content));
        } else {
          this.onChange.emit(null);
          return of([]);
        }
      }),
      tap(() => (this.loading = false))
    );
  }

  ngAfterViewInit(): void {
    // this.fetchAll();
  }

  handleSelect(event: MatOptionSelectionChange, f: FranchiseResponseDTO) {
    if (event.isUserInput) {
      this.onChange.emit(f);
    }
  }

  public clean(): void {
    this.searchForm.reset();
  }

  private fetchAll() {
    this.loading = true;
    this.franchiseService
      .listWithFilters({ page: 0, size: 50, sort: "name,asc" })
      .subscribe((page) => {
        this.loading = false;
        this.franchise.setValue("");
      });
  }
}
